module.exports = __webpack_public_path__ + "img/demand.e303c749.svg";